import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const KVKK = loadable(() => pMinDelay(import('./KVKK'), 300), {
  fallback: <Loading />
});

const AsyncKVKK = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <KVKK { ...props } />
    </ApplicationLayout>
  );
};

AsyncKVKK.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncKVKK;
